import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useStateIfMounted } from "use-state-if-mounted";
import useFetchData from "../../../../hooks/useFetchData";
import { DEFAULT_RATING_CURVE_STATE } from "./RatingCurvesConstants";

export const useRatingCurveInfo = (selectedRatingCurve) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_RATING_CURVE_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedRatingCurve) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_RATING_CURVE_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["flow-from-stage", selectedRatingCurve],
    async () => {
      if (!selectedRatingCurve) {
        setIsDirty(false);
        setEditorState(DEFAULT_RATING_CURVE_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/flow-from-stage/${selectedRatingCurve}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [measurementLocationsLookup] = useFetchData(
    "ui-rating-curve-measurement-locations",
    [],
    true
  );

  const [typesLookup] = useFetchData("ui-rating-curve-types", [], true);

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      measurementLocations: measurementLocationsLookup,
      types: typesLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
